export default __webpack_public_path__ + "static/media/feb2024-5.55a77a3d.jpg";